(() => {
  const bindFaq = (root = document) => {
    root.querySelectorAll('.jc-home-faq').forEach((faq) => {
      if (faq.dataset.jcFaqBound === 'true') return;
      faq.dataset.jcFaqBound = 'true';
      faq.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        faq.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };
  document.addEventListener('DOMContentLoaded', () => bindFaq());
  document.addEventListener('shopify:section:load', (event) => bindFaq(event.target));
})();
